import { inject, Injectable } from '@angular/core';
import { ProvidersService } from '../providers/providers.service';
import { filter, map, Observable, shareReplay, take } from 'rxjs';
import { DrahimProvider } from './schemas';
import { Providers, ProviderStatus } from './enums';

@Injectable({ providedIn: 'root' })
export class ConstantsService {
    private readonly providersService: ProvidersService = inject(ProvidersService);

    public readonly providers: Observable<DrahimProvider[]> = this.providersService.getProvidersList().pipe(
        take(1),
        filter((res) => !!res),
        map((res) => {
            res.push({
                provider_name: Providers.SNBC,
                logo: 'https://image.drahim.sa/drahim/u/01JTR2AS09JN96YNX0CQWTB2Z7/snb-capital',
                label: { ar: 'الأهلي كابيتال', en: 'SNBC' },
                status: ProviderStatus.Active,
            })
            return res;
        }),
        shareReplay(),
    );
}
